<template>
  <b-modal
    :id="modalId"
    content-class=""
    centered
    title="BootstrapVue"
    :hide-footer="false"
    :hide-header="false"
    size="lg"
  >
    <template slot="modal-header">
      <slot name="header"></slot>
      <button
        type="button"
        class="close"
        data-dismiss="modal"
        @click="$bvModal.hide(modalId)"
      >
        &times;
      </button>
    </template>
    <slot name="modal-body-1"></slot>
    <slot name="modal-body-2"></slot>
    <template v-slot:modal-footer="{ actions }">
      <slot name="footer"></slot>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: ['modalId', 'actions'],
  name: 'SplitModal',
}
</script>

<style lang="scss">
/*.modal-body {
  padding: 0px !important;
}*/
#combo-items-container___BV_modal_body_ {
    display: flex;
    flex-wrap: wrap;
    margin-right: -$px10;
    margin-left: -$px10;
}
</style>
